import styled from 'styled-components';

export const PropertyDetailsNavWrapper = styled.div`
  max-width: 1300px;
  @media only screen and (max-width: 1480px) {
    margin-left: 38px;
  }
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 38px;

  @media print {
    margin: 0 38px;
  }

  .rs-nav-item {
    .rs-nav-item-content {
      font-family: Nunito Sans;
      font-size: 14px;
      font-weight: 600;
      color: #101938;
      padding-left: 0;
      padding-right: 0;
      margin-right: 38px;

      @media print {
        -webkit-mask-image: none !important;
      }
    }
  }

  .rs-nav-item-disabled > .rs-nav-item-content {
    color: #c5c6c7 !important;
  }

  .rs-nav-item.rs-nav-item-active {
    .rs-nav-item-content {
      :hover,
      :focus,
      :active {
        color: #101938;
      }
    }
  }

  .rs-nav-item > .rs-nav-item-content {
    :before {
      background-color: #101938 !important;
    }
  }
`;
